import { eventSiteHandler } from './eventSiteHandler';
import { isListingIframePageview } from './isListingIframePageview';
import { pageviewSiteHandler } from './pageviewSiteHandler';
import { teaserHandler } from './teaserHandler';
import { IAnalyticsMessage } from '../../types';

let latestPage: unknown;

export function analyticsMessageHandler(message: IAnalyticsMessage) {
  const [eventType] = message.value;
  switch (eventType) {
    case 'eventSite':
      eventSiteHandler(message.value, latestPage);
      break;

    case 'pageviewSite':
      if (isListingIframePageview(message.value[1])) {
        break;
      }

      pageviewSiteHandler(message.value);
      latestPage = message.value[1].page || null;
      break;

    case 'teaser':
      teaserHandler(message.value, latestPage);
      break;
  }
}
